interface RefreshAccessTokenRequest {
	apiUrl?: string | null;
}

type RefreshPayload =
	| {
			data?: {
				access_token?: unknown;
				accessToken?: unknown;
			};
			access_token?: unknown;
			accessToken?: unknown;
	  }
	| null
	| undefined;

const joinApiPath = (apiUrl: string, path: string): string =>
	`${apiUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;

let inFlightRefresh: Promise<string | null> | null = null;

export const extractAccessTokenFromRefreshPayload = (
	payload: RefreshPayload,
): string | null => {
	const token =
		payload?.data?.access_token ??
		payload?.data?.accessToken ??
		payload?.access_token ??
		payload?.accessToken;
	return typeof token === 'string' && token.trim() ? token : null;
};

export const refreshAccessTokenFromSession = async ({
	apiUrl,
}: RefreshAccessTokenRequest): Promise<string | null> => {
	if (inFlightRefresh) {
		return inFlightRefresh;
	}

	inFlightRefresh = performRefreshAccessTokenFromSession({
		apiUrl,
	}).finally(() => {
		inFlightRefresh = null;
	});

	return inFlightRefresh;
};

const performRefreshAccessTokenFromSession = async ({
	apiUrl,
}: RefreshAccessTokenRequest): Promise<string | null> => {
	const baseUrl = apiUrl?.trim();
	if (!baseUrl) {
		return null;
	}

	try {
		const response = await fetch(joinApiPath(baseUrl, 'refresh-token'), {
			method: 'GET',
			credentials: 'include',
			headers: { Accept: 'application/json' },
		});
		if (!response.ok) {
			return null;
		}

		const payload = (await response.json()) as RefreshPayload;
		return extractAccessTokenFromRefreshPayload(payload);
	} catch {
		return null;
	}
};

export const __testing = {
	joinApiPath,
	performRefreshAccessTokenFromSession,
};
